import { render, staticRenderFns } from "./hlywTips.vue?vue&type=template&id=5cd1db06&scoped=true"
import script from "./hlywTips.vue?vue&type=script&lang=js"
export * from "./hlywTips.vue?vue&type=script&lang=js"
import style0 from "./hlywTips.vue?vue&type=style&index=0&id=5cd1db06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1db06",
  null
  
)

export default component.exports